(ns ui.view.card.counterparty-diligence-responder.view
  (:require
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]
   [ui.view.card.counterparty-diligence-responder.event :as event]
   [ui.view.card.counterparty-diligence-responder.sub :as sub]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]))

(defn no-responder-view
  [{:keys [ctx]}]
  [:div
   {:class "h-64 flex flex-col items-center justify-center"}
   [:div
    {:class "flex flex-col items-center justify-center gap-5"}
    [:i
     {:class "fal fa-user text-4xl text-base-light-text-paler"}]
    [:p "Add responder"]
    [:div
     {:class "w-96"}
     [data-input/view
      {:editor-type        :editor.type/search
       :field/entity-types [:entity.type/person]
       :data-type          :data.type/ref-single
       :on-change          (fn [value opts]
                             (rf/dispatch [::event/update-responder ctx {:value value}])
                             (js/console.log "VALue " value ": " opts))
       :placeholder        "Add responder..."}]]]])

(defn responder-view
  [{:keys [ctx]}]
  (let [responder @(rf/subscribe [::sub/responder ctx])]
    [:div
     {:class "flex flex-col gap-5 mb-5"}
     [:div
      {:class "flex"}
      [:div
       {:class "w-1/2"}
       [:p "First name"]
       [:p (:person/first-name responder)]]

      [:div
       {:class "w-1/2"}
       [:p "Last name"]
       [:p (:person/last-name responder)]]]

     [:div
      {:class "flex"}
      [:div
       {:class "w-1/2"}
       [:p "Email"]
       [:p (:person/universal-email-address responder)]]

      [:div
       {:class "w-1/2"}
       [:p "Phone"]
       [:p (:person/universal-phone-number responder)]]]]))

(defn content
  [{:keys [ctx] :as props}]
  (let [responder? @(rf/subscribe [::sub/responder? ctx])]
    (if responder?
      [responder-view props]
      [no-responder-view props])))

(defn actions
  [{:keys [ctx]}]
  (let [responder? @(rf/subscribe [::sub/responder? ctx])]
    (if responder?
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::event/update-responder ctx {:value nil}])}
       "Remove responder"]
      [:div])))

(defn view
  [{:keys [card] :as props}]
  [card-container/view
   {}
   [:div
    {:class "flex flex-col gap-4"}
    [:div
     {:class "flex justify-between"}
     [card-title/view (:card/title card)]
     [actions props]]
    [content props]]])
